/** Deliberately excludes autoplay, camera and microphone. */
export const YOUTUBE_IFRAME_ALLOW =
	'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture';

export const YOUTUBE_EMBED_WIDTH = 640;
export const YOUTUBE_EMBED_HEIGHT = 360;

export const YOUTUBE_INVALID_URL_ERROR = 'Enter a valid YouTube video link.';
